<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <!--<b-col cols="12">-->
          <!--<div-->
                  <!--v-if="isLoading"-->
                  <!--class="alert alert-info">{{$t('alerts.loading')}}...</div>-->
          <!--<div-->
                  <!--v-if="deletedItem"-->
                  <!--class="alert alert-success">{{ deletedItem['brandTitle'] }} deleted.</div>-->
          <!--<div-->
                  <!--v-if="error"-->
                  <!--class="alert alert-danger">{{ error }}</div>-->
        <!--</b-col>-->
        <b-col cols="12">
          <b-row>
            <b-col class="text-right">
              <router-link
                :to="{ name: 'EXCMDeviceTypeCreate' }"
                class="btn btn-primary">{{$t('buttons.create')}}</router-link>
            </b-col>
          </b-row>
          <b-card>
            <div v-if="items.length">
              <table class="table table-sm table-striped table-hover">
                <thead>
                <tr>
                  <th>{{$t('views.excmdevicetype.list.titleSingle')}}</th>
                  <th colspan="1" />
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="item in items"
                        :key="item['@id']">
                  <td>
                    {{ item['title'] }}
                  </td>
                  <td>
                    <router-link :to="{name: 'EXCMDeviceTypeUpdate', params: { id: item['@id'] }}">
                      <button class="float-right btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                    </router-link>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-if="view">
              <pagination
                :view="view"
                @getPage="getPage($event)"
              ></pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },

  computed: mapGetters({
    deletedItem: 'excmdevicetype/del/deleted',
    error: 'excmdevicetype/list/error',
    items: 'excmdevicetype/list/items',
    isLoading: 'excmdevicetype/list/isLoading',
    view: 'excmdevicetype/list/view'
  }),

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceTypeList')
  },

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'excmdevicetype/list/default'
  })
}
</script>
